/* assets/cl-weather.js */
(function() {
  // CONFIGURATION
  const API_KEY = "3aa0a8ae49ac3f8c4fc1446d1d2e2b5b"; 
  
  // ICON MAPPING (New)
  const ICONS = {
    sunny: "https://cdn.shopify.com/s/files/1/0756/5452/9281/files/sun.svg?v=1765892813",
    clearNight: "https://cdn.shopify.com/s/files/1/0756/5452/9281/files/night.svg?v=1765893020",
    partlyCloudyDay: "https://cdn.shopify.com/s/files/1/0756/5452/9281/files/partlycloudy.svg?v=1765892868",
    partlyCloudyNight: "https://cdn.shopify.com/s/files/1/0756/5452/9281/files/partly-cloud-in-the-night.svg?v=1765893117",
    cloudy: "https://cdn.shopify.com/s/files/1/0756/5452/9281/files/cloudy.svg?v=1765892891",
    rain: "https://cdn.shopify.com/s/files/1/0756/5452/9281/files/heavy-rain.svg?v=1765892919",
    snow: "https://cdn.shopify.com/s/files/1/0756/5452/9281/files/snowflake.svg?v=1765892943",
    thunder: "https://cdn.shopify.com/s/files/1/0756/5452/9281/files/thunder.svg?v=1765892972"
  };

  // PRODUCT & COLLECTION LINKS
  const LINKS = {
    bodyKits: "/collections/carbon-loom-carbon-fiber-body-kits",
    phoneCases: "/collections/carbon-loom-premium-phone-cases",
    pickleball: "/products/cl-carbon-fiber-ultralight-pickleball-paddle",
    badminton: "/products/professional-ultralight-carbon-fiber-badminton-racket",
    tennis: "/products/real-forged-carbon-fiber-ultralight-performance-tennis-racquet",
    snowboard: "/products/real-carbon-fiber-ultralight-snowboard",
    umbrella: "/products/premium-windproof-carbon-fiber-umbrella",
    luggage: "/products/real-carbon-fiber-carry-on-luggage"
  };

  // DOM Elements
  const root = document.getElementById('cl-weather-root');
  const tab = document.getElementById('clw-tab-trigger');
  const minBtn = document.getElementById('clw-minimize-btn');
  const bg = document.getElementById('clw-bg');
  
  // State Containers
  const viewLoading = document.getElementById('clw-loading');
  const viewManual = document.getElementById('clw-manual');
  const viewData = document.getElementById('clw-data');

  // --- 1. STATE MANAGEMENT ---
  const isMobile = window.innerWidth < 768;
  const savedState = localStorage.getItem('clw_state');
  
  if (savedState === 'minimized') root.classList.add('minimized');
  else root.classList.remove('minimized');

  function toggleWidget() {
    if (isMobile) {
      root.classList.toggle('expanded-mobile');
    } else {
      root.classList.toggle('minimized');
      localStorage.setItem('clw_state', root.classList.contains('minimized') ? 'minimized' : 'expanded');
    }
  }

  tab.addEventListener('click', toggleWidget);
  minBtn.addEventListener('click', toggleWidget);

  // --- 2. WEATHER LOGIC ---
  const CACHE_KEY = 'clw_data_cache';
  const CACHE_TIME = 1000 * 60 * 30; // 30 mins

  async function initWeather() {
    const cached = localStorage.getItem(CACHE_KEY);
    if (cached) {
      const { timestamp, data } = JSON.parse(cached);
      if (Date.now() - timestamp < CACHE_TIME) {
        renderWeather(data);
        return;
      }
    }

    try {
      const ipResp = await fetch('https://ipapi.co/json/');
      if (!ipResp.ok) throw new Error('IP Lookup failed');
      const ipData = await ipResp.json();
      fetchWeatherData(ipData.latitude, ipData.longitude);
    } catch (e) {
      showManualInput();
    }
  }

  function showManualInput() {
    viewLoading.classList.add('clw-state-hidden');
    viewManual.classList.remove('clw-state-hidden');
    
    document.getElementById('clw-location-form').addEventListener('submit', (e) => {
      e.preventDefault();
      const city = document.getElementById('clw-city-input').value;
      fetchWeatherDataByCity(city);
    });
  }

  async function fetchWeatherDataByCity(city) {
    viewManual.classList.add('clw-state-hidden');
    viewLoading.classList.remove('clw-state-hidden');
    const url = `https://api.openweathermap.org/data/2.5/forecast?q=${city}&units=metric&cnt=32&appid=${API_KEY}`;
    processFetch(url);
  }

  async function fetchWeatherData(lat, lon) {
    const url = `https://api.openweathermap.org/data/2.5/forecast?lat=${lat}&lon=${lon}&units=metric&cnt=32&appid=${API_KEY}`;
    processFetch(url);
  }

  async function processFetch(url) {
    try {
      const resp = await fetch(url);
      if (!resp.ok) throw new Error('Weather API error');
      const data = await resp.json();
      
      localStorage.setItem(CACHE_KEY, JSON.stringify({ timestamp: Date.now(), data: data }));
      renderWeather(data);
    } catch (e) {
      showManualInput();
    }
  }

  // --- 3. RENDERING ---
  function renderWeather(data) {
    viewLoading.classList.add('clw-state-hidden'); 
    viewManual.classList.add('clw-state-hidden');
    viewData.classList.remove('clw-state-hidden');

    const current = data.list[0];
    const city = data.city.name;
    const temp = Math.round(current.main.temp);
    const desc = current.weather[0].description;
    const iconCode = current.weather[0].icon;
    const weatherId = current.weather[0].id;

    // Update DOM
    document.getElementById('clw-city').textContent = city;
    document.getElementById('clw-temp').textContent = temp;
    document.getElementById('clw-desc').textContent = desc;
    
    // --- ICON LOGIC (UPDATED) ---
    const mainIcon = document.getElementById('clw-icon');
    mainIcon.src = getCustomIconUrl(iconCode);
    mainIcon.className = 'clw-main-icon'; // No tint classes needed
    // ----------------------------

    // Date Logic
    const dateObj = new Date();
    const dayName = dateObj.toLocaleDateString('en-US', { weekday: 'short' });
    const monthDay = dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    const dateContainer = document.getElementById('clw-date-display');
    if (dateContainer) {
       dateContainer.innerHTML = `${dayName}<br>${monthDay}`;
    }

    setThemeAndCTA(weatherId, temp);

    // Process Forecast
    const dailyForecast = {};
    data.list.forEach(item => {
      const date = new Date(item.dt * 1000).toLocaleDateString('en-US', { weekday: 'short' });
      if (!dailyForecast[date]) {
        dailyForecast[date] = { min: item.main.temp, max: item.main.temp, icon: item.weather[0].icon };
      } else {
        dailyForecast[date].min = Math.min(dailyForecast[date].min, item.main.temp);
        dailyForecast[date].max = Math.max(dailyForecast[date].max, item.main.temp);
        if (item.dt_txt.includes("12:00:00")) dailyForecast[date].icon = item.weather[0].icon;
      }
    });

    const forecastContainer = document.getElementById('clw-forecast');
    forecastContainer.innerHTML = '';
    
    // Create the 3 Forecast Boxes
    const days = Object.keys(dailyForecast).slice(0, 3);
    days.forEach(day => {
      const dayData = dailyForecast[day];
      
      const html = `
        <div class="clw-day-col">
          <span class="clw-day-name">${day}</span>
          <img class="clw-day-icon" src="${getCustomIconUrl(dayData.icon)}" />
          <span class="clw-day-temp">${Math.round(dayData.max)}°</span>
        </div>
      `;
      forecastContainer.insertAdjacentHTML('beforeend', html);
    });
  }

  // --- HELPER: Maps OWM Codes to Custom Shopify SVGs ---
  function getCustomIconUrl(code) {
    // 01d = Clear Day
    if (code === '01d') return ICONS.sunny;
    // 01n = Clear Night
    if (code === '01n') return ICONS.clearNight;
    
    // 02d = Few Clouds Day
    if (code === '02d') return ICONS.partlyCloudyDay;
    // 02n = Few Clouds Night
    if (code === '02n') return ICONS.partlyCloudyNight;

    // 03/04 = Cloudy (Day/Night)
    if (['03d','03n','04d','04n'].includes(code)) return ICONS.cloudy;

    // 09/10 = Rain
    if (['09d','09n','10d','10n'].includes(code)) return ICONS.rain;

    // 11 = Thunder
    if (['11d','11n'].includes(code)) return ICONS.thunder;

    // 13 = Snow
    if (['13d','13n'].includes(code)) return ICONS.snow;

    // Default Fallback (Cloudy)
    return ICONS.cloudy;
  }

  /* * LOGIC ENGINE (UNTOUCHED)
   * Determines the Message and Link based on Weather, Time, and Weighting
   */
  function setThemeAndCTA(id, temp) {
    const ctaLink = document.getElementById('clw-cta-link');
    const ctaText = document.getElementById('clw-cta-text');
    bg.className = 'clw-bg-layer';

    // 1. Determine Visual Theme
    let condition = 'cloudy';
    if (id >= 200 && id < 300) condition = 'thunder';
    else if (id >= 300 && id < 600) condition = 'rain';
    else if (id >= 600 && id < 700) condition = 'snow';
    else if (id === 800) condition = 'sunny';
    
    bg.classList.add('bg-' + condition);

    // 2. Determine Logic Variables
    const date = new Date();
    const hour = date.getHours();
    const day = date.getDay(); // 0 = Sun, 6 = Sat
    
    const isNight = (hour >= 18 || hour < 5);
    const isWeekend = (day === 0 || day === 6);
    
    let text = "";
    let link = "";

    // --- PRIORITY 1: HARD OVERRIDES (Weather) ---
    if (id >= 200 && id < 600) {
      text = "Stay dry. Carbon fiber protection.";
      link = LINKS.umbrella;
    } 
    else if ((id >= 600 && id < 700) || temp < 0) {
      if (temp < 0 && id === 800) text = "The slopes are calling.";
      else text = "Fresh powder. Time to ride.";
      link = LINKS.snowboard;
    }

    // --- PRIORITY 2: TIME BASED ---
    else if (isNight) {
      if (Math.random() > 0.5) {
        text = "City lights look better in Carbon.";
        link = LINKS.bodyKits;
      } else {
        text = "Quiet night. Refresh your device.";
        link = LINKS.phoneCases;
      }
    }
    else if (isWeekend) {
      if (Math.random() > 0.5) {
        text = "Maybe it's time to call someone you're thinking of.";
        link = LINKS.phoneCases;
      } else {
        text = "Weekend getaway? Pack light.";
        link = LINKS.luggage;
      }
    }

    // --- PRIORITY 3: STANDARD DAY ---
    else {
      const rand = Math.random();
      if (rand < 0.40) { 
        const sports = [
          { t: "Perfect conditions for the court.", l: LINKS.pickleball },
          { t: "Great weather for badminton.", l: LINKS.badminton },
          { t: "Hit the courts. Tennis time.", l: LINKS.tennis }
        ];
        const pick = sports[Math.floor(Math.random() * sports.length)];
        text = pick.t;
        link = pick.l;
      } 
      else if (rand < 0.70) {
        text = "New case. New phone feel.";
        link = LINKS.phoneCases;
      } 
      else if (rand < 0.90) {
        text = "Planning a trip? Travel lighter.";
        link = LINKS.luggage;
      } 
      else {
        text = "Beautiful day for a drive.";
        link = LINKS.bodyKits;
      }
    }

    // Apply to DOM
    ctaText.textContent = text;
    ctaLink.href = link;
  }

  initWeather();
})();